import { text } from '#contract'
import { useClient } from '../../app/client-context.ts'
import { useView } from '../../app/use-view.ts'
import { SettingRow } from '../../components/setting-row.tsx'
import { Toggle } from '../../components/toggle.tsx'
import { useT } from '../../i18n/index.ts'
import { ResetSection } from './reset-section.tsx'
import styles from './settings-screen.module.css'

/** The developer-mode flag. The tools that read it arrive in a later phase. */
export function DeveloperTab() {
  const t = useT()
  const client = useClient()
  const enabled = useView((view) => view.settings.dev.enabled)

  return (
    <div class={styles.stack}>
      <SettingRow
        label={t(text('settings.developer.enabled'))}
        description={t(text('settings.developer.description'))}
      >
        <Toggle
          checked={enabled}
          onChange={(next) => {
            client?.updateSettings({ dev: { enabled: next } })
          }}
        />
      </SettingRow>
      <ResetSection section="dev" />
    </div>
  )
}
